/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import articleTypes from '../../constants/articleTypes';

const ReviewContent = ({content, getRaw}) => { 
    return (
        content.ReviewBody.map((paragraph, i) =>
            <p key={i} dangerouslySetInnerHTML={getRaw(paragraph)} />
        )
    );
};

export default ReviewContent;

ReviewContent.propTypes = {
    content: PropTypes.object,
    getRaw: PropTypes.func.isRequired
};